import axios from 'axios'
import { EXCLUIR_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirTrecho (idItinerario, idEmpresa) {
  const url = `${URL}/itinerario/${idItinerario}/empresa/${idEmpresa}/excluir`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_ITINERARIO,
        payload: { ...response.data, idItinerario }
      })
  );
}
